import { ProductType, useGetAdQuery } from '@/models/ad';
import { useGetAreaQuery, useGetZonesQuery } from '@/models/location';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
// import { PageSkeleton } from './pageSkeleton';

export const EditAd = () => {
  const { id } = useParams();
  const adQuery = useGetAdQuery({ id: id || '' }, { skip: !id });
  const { data: ad } = adQuery;
  const { data: area } = useGetAreaQuery(
    { areaId: ad?.zones[0]?.zone.area.id || 0 },
    { skip: !ad }
  );
  const { data: zones } = useGetZonesQuery(
    { areaId: ad?.zones[0]?.zone.area.id || 0 },
    { skip: !ad }
  );

  const [result, setResult] = useState<any>();
  const [selected, setSelected] = useState<number[]>([]);
  const [productType, setProductType] = useState<string | undefined>(
    ProductType.Image
  );
  const [mediaUrl, setMediaUrl] = useState<string | undefined>('');

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        const result = await Promise.all([adQuery, area, zones]);
        if (isMounted && result) {
          setResult(result);
          setProductType(result[0].currentData?.type);
          setMediaUrl(result[0].currentData?.url);
          const selected = ad?.zones.map((zone) => zone.zone.id);
          if (selected) {
            setSelected(selected);
          }
        }
      } catch (error) {
        console.log({ error });
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [adQuery, area, zones]);

  const data = {
    id,
    area: result && result[1],
    zones: result && result[2],
    selectedZones: selected,
    ad,
    productType,
    mediaUrl,
  };

  console.log('🚀 ~ data:', data);

  return (
    // <PageSkeleton
    //   hasSelector={false}
    //   type="edit"
    //   showSummary={false}
    //   hasMap={true}
    //   mapData={data}
    // />
    <></>
  );
};
